import React, { useState } from "react";
import "./ProformaLocated.css";
import { useConfirmExistingProformaMutation } from "../../services/proformaApi";
import Loader from "../Loader";
import { tracker } from "../../services/mixpanel";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
const ProformaLocated: React.FC<ProformaLocatedProps> = ({
  isMatch,
  setIsProformaLocatedModalOpen,
  proformaId,
  contactEmail,
  message,
  isAlreadyFinalized,
}) => {
  const [confirmExistingProforma] = useConfirmExistingProformaMutation();
  const [isLoading, setIsLoading] = useState(false);
  const username = useSelector(
    (state: RootState) => state.proformaUser?.name
  );
  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      const response = await confirmExistingProforma({
        proformaId: proformaId,
        contactEmail: contactEmail,
      }).unwrap();
      tracker.proforma.finalizeProformaSuccess();
    } catch (error: any) {
      console.log("error:", error);
      const message = error?.data?.message ?? "An error occurred during confirm.";
      tracker.proforma.finalizeProformaFailed(username, message);
    } finally {
      setIsLoading(false);
      setIsProformaLocatedModalOpen(false);
    }
  };
  const handleClose = () => {
    setIsProformaLocatedModalOpen(false);
  };
  return (
    <div className="proforma-container">
      <div className="proforma-title">
        {isMatch ? "PROFORMA MATCHED" : "PROFORMA MISMATCH"}
      </div>
      <div className="proforma-message">
        {message}

        {!isAlreadyFinalized && isMatch && (
          <p className="proforma-messages">
            Please Confirm this is Final Proforma for {new Date().getFullYear()}{" "}
            ?
          </p>
        )}
      </div>
      {
        <div className="proforma-buttons">
          {isMatch ? (
            !isAlreadyFinalized && (
              <>
                <button className="proforma-button" onClick={handleClose}>
                  Reject
                </button>
                <button className="proforma-button" onClick={handleConfirm}>
                  {isLoading ? (
                    <Loader isLoading={isLoading} size={18} />
                  ) : (
                    "Confirm"
                  )}
                </button>
              </>
            )
          ) : (
            <button className="proforma-button" onClick={handleClose}>
              Close
            </button>
          )}
        </div>
      }
    </div>
  );
};

export default ProformaLocated;
